module.exports = __webpack_public_path__ + "static/media/peterArt12.fe97bbea.jpg";